<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          v-if="
            mode == 0 &&
              (bank == null ||
                bank.bankId == -1 ||
                branch == null ||
                branch.BranchId == -1)
          "
          class="mr-1"
          small
          color="primary"
          v-on="tooltip"
          dark
          @click="chooseFilters"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="mr-1"
          small
          color="primary"
          dark
          v-on="{ ...tooltip }"
          v-on:click="onOpen"
        >
          <v-icon>{{
            `${mode === 0 ? "mdi-plus" : "mdi-pencil-outline"}`
          }}</v-icon>
        </v-btn>
      </template>
      <span>{{
        `${mode === 0 ? $t("kiosks.create") : $t("kiosks.edit")}`
      }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="800">
        <v-card-title>
          <span class="headline">{{
            `${
              mode === 0
                ? $t("kiosks.createKiosk")
                : $t("kiosks.editKiosk")
            }`
          }}</span>
        </v-card-title>
        <v-card-text style="overflow-y: auto;  max-height: 400px">
          <v-container>
            <RequiredTextField
              v-model="currentDevice.bankName"
              title="referenceBooks.banks.Bank"
              :disabled="true"
            />
            <RequiredTextField
              v-model="currentDevice.branchName"
              title="referenceBooks.branches.Branch"
              :disabled="true"
            />
            <RequiredTextField
              v-model="currentDevice.kioskName"
              :needCheck="executeButtonClick"
              title="kiosks.name"
            />
            <RequiredTextField
              v-model="currentDevice.link"
              :needCheck="executeButtonClick"
              title="kiosks.link"
            />
            <RequiredTextField
              v-model="currentDevice.alias"
              :needCheck="executeButtonClick"
              title="kiosks.Alias"
            />
            <ComboboxDevs
              v-if="mode !== 1"
              v-model="currentDevice.deviceId"
              :disabled="mode === 1"
              :items="avDevices"
            />
            <v-row class="mr-4 ml-4">
              <v-text-field
                :label="$t('kiosks.address')"
                v-model="currentDevice.address"
              />
            </v-row>
          </v-container>
          <small class="mr-4 ml-4"
            >*{{ $t("referenceBooks.requiredFields") }}</small
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
          <v-btn
            v-if="mode === 0"
            color="blue darken-1"
            text
            @click="createDevice"
            >{{ $t("Create") }}</v-btn
          >
          <v-btn v-else color="blue darken-1" text @click="saveDevice">{{
            $t("Save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
import RequiredTextField from '@/components/CommonComponents/RequiredTextField.vue';
import ComboboxDevs from '@/components/Kiosks/DevicesComboboxDialog';
import Vue from 'vue';
import { notifyError, notifySuccess } from '@/services/notifications';

export default {
  components: {
    DragForm,
    RequiredTextField,
    ComboboxDevs,
  },
  props: {
    mode: {
      type: Number,
      defaultItem: 0,
    },
    device: {
      type: Object,
      default: null,
    },
    bank: {
      type: Object,
      default: null,
    },
    branch: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentDevice: {
        kioskName: '',
        bankId: -1,
        bankName: '',
        branchId: -1,
        deviceId: -1,
        deviceName: '',
        branchName: '',
        link: '',
        alias: '',
        address: '',
      },
      dialog: false,
      bankName: '',
      avDevices: null,

      busyValues: {
        Name: [],
        Alias: [],
        Link: [],
      },
      needCheck: [
        { propName: 'alias', type: 0, busyName: 'Alias' },
        { propName: 'link', type: 0, busyName: 'Link' },
        { propName: 'kioskName', type: 0, busyName: 'Name' },
      ],
      executeButtonClick: false,
    };
  },
  watch: {
    dialog(flag) {
      if (flag) {
        this.loadDefault();
        if (this.mode === 0) this.loadModeNull();
        else this.loadModeOne();
      } else this.clear();
    },
  },
  methods: {
    async onOpen() {
      if (this.mode !== 1) {
        await this.setAvailableDevices();

        if (this.avDevices === null || this.avDevices.length === 0) {
          this.showMessage(
            this.$t('Error'),
            `${this.$t('kiosks.notAvailableDevs')}`,
            'error'
          );

          return;
        }
      }

      this.dialog = !this.dialog;
    },
    checkFields() {
      let result = true;

      this.needCheck.forEach((field) => {
        let errors;
        if (field.type == 0)
          errors = this.checkText(
            this.currentDevice[field.propName],
            field.busyName
          );
        else errors = this.checkId(this.currentDevice[field.propName]);

        if (errors != null && errors != '') {
          this.showMessage(
            `${this.$t('ErrorInField')}: ${
              this.propertiesResponse[field.busyName]
            }`,
            errors,
            'error'
          );
          result = false;
        }
      });

      return result;
    },
    checkId(id) {
      if (id < 1) return this.$t('validations.notEmpty');

      return '';
    },
    checkText(value, ind = null) {
      if (value == null || value.length == 0)
        return this.$t('validations.notEmpty');

      if (ind != null) {
        if (this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    clear() {
      this.currentDevice = {
        kioskId: '',
        kioskName: '',
        bankId: -1,
        deviceId: -1,
        deviceName: '',
        bankName: '',
        branchId: -1,
        branchName: '',
        link: '',
        alias: '',
        address: '',
      };

      this.bankName = '';

      this.executeButtonClick = false;
    },
    loadDefault() {
      this.setBank();
    },
    setBank() {
      if (this.bank != null) this.bankName = this.bank.bankName;
    },
    loadModeNull() {
      if (this.bank != null) {
        this.currentDevice.bankId = this.bank.bankId;
        this.currentDevice.bankName = this.bank.bankName;
      }
      if (this.branch != null) {
        this.currentDevice.branchId = this.branch.branchId;
        this.currentDevice.branchName = this.branch.name;
        this.setAvailableDevices();
      }
    },
    async setAvailableDevices() {
      await this.$axios.kiosks
        .getAvailableDevicesBr(this.branch.branchId)
        .then((response) => response.data)
        .then((json) => {
          this.avDevices = json;
          if (this.mode !== 1 && this.avDevices.length === 1)
            this.currentDevice.deviceId = this.avDevices[0].deviceId;
        })
        .catch((error) => {
          console.error(error);

          notifyError('', 'Error get available devices');
          this.catchErrors(error);
        });
    },
    loadModeOne() {
      if (this.device != null) {
        Object.assign(this.currentDevice, this.device);
      }
    },
    chooseFilters() {
      if (this.bank == null || this.bank.bankId == -1)
        this.showMessage(
          this.$t('Error'),
          this.$t('referenceBooks.banks.ChooseSomeBank'),
          'error'
        );
      else
        this.showMessage(
          this.$t('Error'),
          this.$t('referenceBooks.branches.ChooseSomeBranch'),
          'error'
        );
    },
    createDevice() {
      this.executeButtonClick = true;

      if (!this.checkFields()) return;

      this.$axios.kiosks
        .post({
          kioskId: '99999999-9999-9999-9999-999999999999',
          kioskName: this.currentDevice.kioskName,
          address: this.currentDevice.address,
          branchId: this.currentDevice.branchId,
          deviceId: this.currentDevice.deviceId,
          bankId: this.currentDevice.bankId,
          link: this.currentDevice.link,
          alias: this.currentDevice.alias,
        })
        .then((response) => {
          if (response.status == 200) {
            const id = response.data;
            notifySuccess(
              '',
              this.$t('Messages.DeviceWasCreated', [
                this.currentDevice.deviceName,
              ])
            );
            this.$emit(
              'created',
              response.status,
              this.currentDevice.deviceName,
              id
            );
            this.dialog = false;
          }
        })
        .catch((error) => {
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileCreatingDevice', [
              this.currentDevice.deviceName,
            ])
          );
          this.catchErrors(error);
        });
    },
    catchErrors(error, errorHeader = '') {
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      } else {
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error) {
      switch (data.errorType) {
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value) {
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${
        this.propertiesResponse[property]
      }`;

      this.showMessage(
        errorInField,
        this.$t('errorsMessages.BusyName'),
        'error'
      );
    },
    onNoRigths(errorHeader = '') {
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    saveDevice() {
      this.executeButtonClick = true;

      if (!this.checkFields()) return;

      const data = this.currentDevice;

      this.$axios.kiosks
        .put(this.currentDevice.kioskId, {
          kioskId: this.currentDevice.kioskId,
          kioskName: this.currentDevice.kioskName,
          address: this.currentDevice.address,
          branchId: this.currentDevice.branchId,
          deviceId: this.currentDevice.deviceId,
          bankId: this.currentDevice.bankId,
          link: this.currentDevice.link,
          alias: this.currentDevice.alias,
        })
        .then((response) => {
          notifySuccess(
            '',
            this.$t('Messages.DeviceWasEdited', [data.deviceName])
          );
          this.$emit('saved', response.status, data);
          this.dialog = false;
        })
        .catch((error) => {
          console.error(error);

          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileEditingDevice', [
              data.deviceName,
            ])
          );
          this.catchErrors(error);
        });

      this.dialog = false;
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
};
</script>
